import { queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '../api/client';
import { STALE } from '../api/stale';
import { COUNTRIES, type Country } from '../lib/countries';

/** Banks, products, teams, users and document types. Reference data used by every feature. */
export const lookupsQuery = queryOptions({
  queryKey: ['lookups'] as const,
  queryFn: ({ signal }) => unwrap(api.GET('/lookups', { signal })),
  staleTime: STALE.reference,
});

/**
 * ISO 3166-1 alpha-2 countries (GET /reference/countries). Static reference data: the bundled dataset is shown
 * immediately (placeholder) and the request confirms it once per session.
 */
export const countriesQuery = queryOptions({
  queryKey: ['reference', 'countries'] as const,
  queryFn: async ({ signal }) => (await unwrap(api.GET('/reference/countries', { signal }))).items,
  staleTime: Infinity,
  gcTime: Infinity,
  placeholderData: COUNTRIES as Country[],
});
